import { gql } from '@apollo/client'

export const CREATE_STRIPE_CONNECTION_LINK = gql`
  mutation CreateStripeConnectionLink($countryCode: String!) {
    createStripeConnectionLink(countryCode: $countryCode)
  }
`

export const CREATE_STRIPE_LOGIN_LINK_MUTATION = gql`
  mutation CreateStripeLoginLink {
    createStripeLoginLink
  }
`
export const DISCONNECT_STRIPE_MUTATION = gql`
  mutation DisconnectExpertFromStripe {
    disconnectExpertFromStripe {
      id
    }
  }
`
